import {ShaderMaterial, Uniform} from "three";

export default class SelectionMaterial extends ShaderMaterial {
    isHovered = false;
    constructor() {
        super();
        this.uniforms = {
            hoverIntensity: new Uniform(0.0),
        }
        this.opacity = 1;
        this.transparent = true;
        this.side = 2;
        this.vertexShader = `
varying vec2 vUv;

#include <common>
#include <logdepthbuf_pars_vertex>

void main() {
  gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
  vUv = uv;
}`;
        this.fragmentShader = `
uniform float hoverIntensity;
varying vec2 vUv;
uniform sampler2D dotTex;
void main() {
    gl_FragColor = mix(
        vec4(
            1.0, 
            1.0, 
            1.0, 
            clamp(
                mix(
                    0.0, 
                    1.0, 
                    hoverIntensity * 3.0
                ), 
                0.0, 
                1.0
             )
        ),
        vec4(1.0, 1.0, 1.0, 0.0),
        vUv.x * mix(2.5, 1.6, hoverIntensity)
    );
}`
    }
}